import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';

export const generateManifestCommand = (
  services: AstroCommandServices,
  cliVersion: string
) =>
  createCommand('manifest')
    .description('Generate manifest for project extensions')
    .action(async (_, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { GenerateManifestCommand } = await import(
        '../components/GenerateManifestCommand/index.js'
      );
      await renderCommand(
        command,
        services,
        cliVersion,
        <GenerateManifestCommand />
      );
    });
